<template>
  <td data-int="cart-cell-availability">
    <span v-if="item.partUnavailable">{{ $t('notAvailable') }}</span>
    <span v-else>{{ item.availability }}</span>
  </td>
</template>

<script>
export default {
  name: 'CartCellAvailability',
  props: {
    item: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>

</style>
